<!--
 * @Author: Sephiroth·D·Kid
 * @Date: 2019-06-27 16:19:44
 * @LastEditors: yuka
 * @LastEditTime: 2019-08-05 17:22:10
 * @Description: 鲸鱼动态
 -->

<template>
  <div class="news-wrapper">
    <router-view></router-view>
  </div>
</template>
<script>
export default {};
</script>
<style lang="less" scope>
.news-wrapper {
  padding-left: 0.2rem;
}
</style>
